// customer 報表/查詢頁群：display 頁型 2 頁的整頁 body（批次 18，Gitea issue #23）。
// 掛在 PageBehavior.complexBody（DisplayPage hooks 前早退；批次 17 兩設定頁先例）。
//
// 行號基準＝raw-dom 擷取檔（2026-09-26 node 腳本親驗）＋api-inventory.md：
//
//   1. clert-cerk（實習證明書，clertCerk.jsp /tsghfunc/toClerkCertPage，train）：
//      queryForm（:1259-1288）＝學年度*/醫院*/訓練類別*/訓練計畫*＋學員（**無 departmentId**）。
//      ready（:1333-1353）＝級聯＋setStudentList＋**organizationId 預設 '1'＋trigger change**。
//      查詢鈕（:1299 `查詢` onclick=doQuery）。doQuery（:1435-1461）：planTargetId undefined/''
//      /<0 → `請選擇訓練計畫`（**無驚嘆號，:1437**）→ `$.post('tsghfunc/getClerkCertListAjax',
//      serialize)` → clear＋rows.add；失敗 showAlertDialog(desc)。
//      表 5 欄（initListTable :1385-1425）：學員（studentIdName）/年度（annualIdName）/
//      訓練計畫（planTargetIdName）/申請（applyDate 有值顯示日期；空→`<button onclick=
//      doApply(settingId)>申請</button>`）/下載（chCertFileId 非空→`下載中文實習證明書`鈕；
//      enCertFileId 非空→`<br>`＋`下載英文實習證明書`鈕）。
//      doApply（:1463-1481）：param={settingId} → `$.post('tsghfunc/doClerkCertApply')` →
//      success→doQuery()＋showInfoDialog(response.desc)；失敗 showAlertDialog(desc)。
//      **doClerkCertApply＝endpoint-map 無條目**（頁面專屬端點）→ 誠實無 data-effect
//      （B1-3 六端點先例，D-1 5-op 凍結等真後端批次）；mock 以 update 寫列上 applyDate。
//
//   2. tsgh-study-history-list（學習歷程下載，tsghStudyHistoryList.jsp /customer/tsgh/studyHistoryList，
//      study-passport）：queryForm（:1365-1415）＝學年度*/醫院*/訓練類別*/部門*/訓練計畫*＋
//      組別（phaseTargetId）＋學員。查詢鈕 #btnQuery（:1423）＋匯出鈕（:1425 `匯出` onclick=doExport）。
//      doQuery（:1581-1603）＝valid() → `$.ajax POST 'training/studyPassport/getPlanInstListAjax'` →
//      success showQuery(list)（clear＋rows.add＋order [3 asc]）；失敗 alert(desc)。
//      **查詢端點未映射**（endpoint-map 無條目；紅線不可擴）→ data-effect 照帶
//      `list:<pageId>`＋endpoint 級 parity 登記。
//      表 #listTable 7 欄（:1460-1491）：歷程（genDownloadBtn :1547-1551＝`下載(完整)`＋`<br>`＋
//      `下載(摘要)` → downloadPassport('true'/'false', id)）/年度（render＝annualId 選中文字，
//      mock 種子 annualIdName）/訓練計畫/學員員編/學號/學員/導師。
//      downloadPassport（:1553-1579）＝showProcessing → GET `prompt/customer/tsgh/
//      chkDownloadStudyHistory?planInstId&isFull` → success→window.open(`downloadStudyHistory?
//      isFull&planInstId`，完整=''、摘要='aa')；失敗 alert(desc)。**頁面專屬端點無條目**→
//      誠實無 data-effect＋雛形提示（B1-3 模式）。
//      doExport（:1504-1544）＝valid() → jobTypeId!=='2' → `匯出 計畫學員於該計畫中的平均成績、
//      排名、百分比 [限 西醫PGY]!`（:1510）→ planTargetId==='-1' → `匯出 需選定訓練計畫`（:1514）→
//      serializeArray＋csrf → fileDownload POST `/prompt/customer/tsgh/allStudyHistory/doExport`；
//      fail 同（查不到資料!/下載檔案失敗！）。**endpoint-map `#export` path 錯置**
//      （downloadStudyHistory ≠ allStudyHistory/doExport）→ data-effect 照帶＋path 差異登記。
//
// 雛形策略：查詢＝list 真打＋種子（批次 14 W2 同款）；申請＝update 寫列上（批次 16 證照先例）；
// 匯出＝runReportExport（D-1 第 2a 點）；列下載＝雛形提示（B1-3 模式）；級聯平列池（D2）。
// 【證據等級】§7 第 3 級（原始碼）。【雛形值待實機校準】

import { useState, type ReactElement, type ReactNode } from 'react';
import { panelHeadingLevelFor } from '@/app/panel-heading-levels';
import { Button } from '@/components/base/Button';
import { Select } from '@/components/base/Select';
import { LINK_TEXT_CLASS } from '@/components/base/shared-classes';
import { Table, type TableColumn } from '@/components/base/Table';
import { TextInput } from '@/components/base/TextInput';
import { ContentPanel, ProcessingOverlay, useDialogs } from '@/components/layouts';
import { LegacyContractModals } from '@/components/layouts/LegacyContractModals';
import { useDataSource } from '@/mocks';
import { selectOptionsOverride } from '@/mocks/legacy-fields';
import type { EffectKey } from '@/mocks/endpoint-map';
import type { Row } from '@/mocks/types';
import {
  ACCOUNT_DEPARTMENT_OPTIONS,
  ACCOUNT_JOB_TYPE_OPTIONS,
  ACCOUNT_ORGANIZATION_OPTIONS,
  COURSE_CLAZZ_ANNUAL_OPTIONS,
  COURSE_CLAZZ_PLAN_TARGET_OPTIONS,
  CUSTOMER_STUDY_HISTORY_JOB_TYPE_OPTIONS,
  CUSTOMER_STUDY_HISTORY_PLAN_TARGET_OPTIONS,
  TRAINING_PHASE_TARGET_OPTIONS,
  TRAINING_STUDENT_OPTIONS,
} from '@/mocks/resource-rules';
import { runReportExport } from '@/pages/report/ReportKit';

/** display 頁共用殼（LegacyContractModals＋ProcessingOverlay＋panel＋查詢區＋動作鈕＋結果表）。 */
function CustomerDisplayShell(props: {
  pageId: string;
  title: string;
  fields: ReactNode;
  actions: ReactNode;
  busy: boolean;
  table: ReactNode;
}): ReactElement {
  return (
    <div data-ui-id={props.pageId}>
      <LegacyContractModals pageId={props.pageId} />
      <ProcessingOverlay uiId={`${props.pageId}-processing`} open={props.busy} />
      <ContentPanel uiId={`${props.pageId}-panel`} title={props.title} headingLevel={panelHeadingLevelFor(props.pageId)}>
        <div data-ui-id={`${props.pageId}-query`} className="mb-4 grid grid-cols-2 gap-x-4 gap-y-2">
          {props.fields}
        </div>
        <div data-ui-id={`${props.pageId}-actions`} className="mb-3 flex gap-2">
          {props.actions}
        </div>
        {props.table}
      </ContentPanel>
    </div>
  );
}

/** 查詢鈕（btn-search／btn-info；dataEffect 由呼叫端給；鈕不 disabled＝批次 17 教訓）。 */
function DisplayQueryButton(props: {
  pageId: string;
  label: string;
  effect: EffectKey | undefined;
  onClick: () => void;
}): ReactElement {
  return (
    <Button
      uiId={`${props.pageId}-query-btn`}
      variant="primary"
      size="sm"
      type="button"
      {...(props.effect === undefined ? {} : { dataEffect: props.effect })}
      onClick={props.onClick}
    >
      {props.label}
    </Button>
  );
}

// ---------------------------------------------------------------------------
// 1. 實習證明書（clert-cerk；complexBody）。
// ---------------------------------------------------------------------------

export function ClertCerkBody({ pageId }: { pageId: string }): ReactElement {
  const dialogs = useDialogs();
  const dataSource = useDataSource();
  const [values, setValues] = useState<Record<string, string>>({
    organizationId: 'org-1',
    annualId: '115',
    jobTypeId: '',
    planTargetId: '',
    searchStudentCode: '',
    studentId: '',
  });
  const [rows, setRows] = useState<readonly Row[]>([]);
  const [busy, setBusy] = useState(false);
  // 批次 52 修訂（b52-calibrate3，F-2）：OPTION_SET_OVERRIDES 命中＝凍結選項集取代寫死常數
  // （規格 §7.1；照已接線 7 檔同構一行式；override 命中含空陣列即移除 placeholder 空選項）。
  const overrideOptions = (name: string) => selectOptionsOverride(pageId, name);
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  /** doQuery（:1435-1461）：planTargetId 空/<0 → `請選擇訓練計畫`（無驚嘆號照實）。 */
  const doQuery = () => {
    void (async () => {
      if (isPlanUnselected(values['planTargetId'])) {
        await dialogs.alert('請選擇訓練計畫');
        return;
      }
      setBusy(true);
      try {
        const result = await dataSource.list(pageId, { page: 1, pageSize: 50, filters: { ...values } });
        setRows(result.rows.filter((row) => row['settingId'] !== undefined));
      } catch (cause: unknown) {
        await dialogs.alert(cause instanceof Error ? cause.message : '查詢失敗');
      } finally {
        setBusy(false);
      }
    })();
  };
  /** doApply（:1463-1481）：doClerkCertApply 頁面專屬端點（endpoint-map 無條目）＝
   *  誠實無 data-effect；mock 以 update 寫列上 applyDate（批次 16 證照先例）→
   *  doQuery()＋showInfoDialog(desc)；失敗 showAlertDialog(desc)。 */
  const doApply = (row: Row) => {
    void (async () => {
      setBusy(true);
      try {
        await dataSource.update(pageId, String(row['id'] ?? ''), { applyDate: '2026/01/15' });
        await doQuery();
        // desc【雛形值待實機校準】（legacy 後端回傳；ClerkCertController.java:112 產生 docx）。
        await dialogs.info('申請成功!');
      } catch (cause: unknown) {
        await dialogs.alert(cause instanceof Error ? cause.message : '申請失敗!');
      } finally {
        setBusy(false);
      }
    })();
  };
  /** 下載實習證明書（downloadFile；window.open 語意→雛形提示，不帶 data-effect）。 */
  const downloadCert = (label: string) => {
    void (async () => {
      await dialogs.info(`雛形不提供檔案下載，「${label}」入口僅示範（legacy 為 docx 下載）。`);
    })();
  };
  const columns: readonly TableColumn[] = [
    { key: 'studentIdName', header: '學員', align: 'center' },
    { key: 'annualIdName', header: '年度', align: 'center' },
    { key: 'planTargetIdName', header: '訓練計畫', align: 'center' },
    { key: 'applyDate', header: '申請', align: 'center' },
    { key: 'download', header: '下載', align: 'left' },
  ];
  return (
    <CustomerDisplayShell
      pageId={pageId}
      title="實習證明書"
      busy={busy}
      actions={
        <DisplayQueryButton pageId={pageId} label="查詢" effect={`list:${pageId}` as EffectKey} onClick={doQuery} />
      }
      table={
        <Table
          uiId={`${pageId}-result-table`}
          columns={columns}
          rows={rows.map((row) => ({ ...row }))}
          rowKey={(row) => String(row['settingId'] ?? '')}
          renderCell={(row, columnKey) => {
            // 申請欄（:1397-1403）：applyDate 有值顯示日期；空→申請鈕。
            if (columnKey === 'applyDate') {
              const applyDate = String(row['applyDate'] ?? '');
              if (applyDate !== '' && applyDate !== 'null') {
                return applyDate;
              }
              return (
                <button
                  type="button"
                  data-ui-id={`${pageId}-apply-${String(row['settingId'] ?? '')}`}
                  className="rounded bg-[#337ab7] px-2 py-1 text-xs text-white"
                  onClick={() => {
                    doApply(row);
                  }}
                >
                  申請
                </button>
              );
            }
            // 下載欄（:1404-1423）：chCertFileId→下載中文實習證明書；enCertFileId→br＋下載英文。
            if (columnKey === 'download') {
              const ch = String(row['chCertFileId'] ?? '');
              const en = String(row['enCertFileId'] ?? '');
              return (
                <>
                  {ch === '' ? null : (
                    <button
                      type="button"
                      data-ui-id={`${pageId}-download-ch-${String(row['settingId'] ?? '')}`}
                      className="mr-1 rounded bg-[#5bc0de] px-2 py-1 text-xs text-white"
                      onClick={() => {
                        downloadCert('下載中文實習證明書');
                      }}
                    >
                      下載中文實習證明書
                    </button>
                  )}
                  {en === '' ? null : (
                    <>
                      <br />
                      <button
                        type="button"
                        data-ui-id={`${pageId}-download-en-${String(row['settingId'] ?? '')}`}
                        className="rounded bg-[#f0ad4e] px-2 py-1 text-xs text-white"
                        onClick={() => {
                          downloadCert('下載英文實習證明書');
                        }}
                      >
                        下載英文實習證明書
                      </button>
                    </>
                  )}
                </>
              );
            }
            const value = row[columnKey];
            return value === null || value === undefined ? '' : String(value);
          }}
        />
      }
      fields={
        <>
          <div>
            <label htmlFor={`${pageId}-field-annual-id`} className="text-sm">
              <span className="text-danger">*</span>學年度：
            </label>
            <Select
              uiId={`${pageId}-field-annual-id`}
              name="annualId"
              value={values['annualId'] ?? ''}
              onChange={(next) => {
                set('annualId', next);
              }}
              options={overrideOptions('annualId') ?? COURSE_CLAZZ_ANNUAL_OPTIONS}
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-organization-id`} className="text-sm">
              <span className="text-danger">*</span>醫院：
            </label>
            <Select
              uiId={`${pageId}-field-organization-id`}
              name="organizationId"
              value={values['organizationId'] ?? ''}
              onChange={(next) => {
                set('organizationId', next);
              }}
              options={overrideOptions('organizationId') ?? ACCOUNT_ORGANIZATION_OPTIONS}
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-job-type-id`} className="text-sm">
              <span className="text-danger">*</span>訓練類別：
            </label>
            <Select
              uiId={`${pageId}-field-job-type-id`}
              name="jobTypeId"
              value={values['jobTypeId'] ?? ''}
              onChange={(next) => {
                set('jobTypeId', next);
              }}
              options={overrideOptions('jobTypeId') ?? ACCOUNT_JOB_TYPE_OPTIONS}
              {...(overrideOptions('jobTypeId') ? {} : { placeholder: '請選擇' })}
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-plan-target-id`} className="text-sm">
              <span className="text-danger">*</span>訓練計畫：
            </label>
            <Select
              uiId={`${pageId}-field-plan-target-id`}
              name="planTargetId"
              value={values['planTargetId'] ?? ''}
              onChange={(next) => {
                set('planTargetId', next);
              }}
              // doQuery 擋鏈（:1436）：凍結 planTargetId 0 options＝未選語意（FROZEN_CHAIN）。
              options={overrideOptions('planTargetId') ?? COURSE_CLAZZ_PLAN_TARGET_OPTIONS}
              {...(overrideOptions('planTargetId') ? {} : { placeholder: '請選擇' })}
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-search-student-code`} className="text-sm">
              學員：
            </label>
            <TextInput
              uiId={`${pageId}-field-search-student-code`}
              name="searchStudentCode"
              value={values['searchStudentCode'] ?? ''}
              onChange={(next) => {
                set('searchStudentCode', next);
              }}
              placeholder="(請輸入學員姓名或學員編號)"
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-student-id`} className="text-sm">
              {' '}
            </label>
            <Select
              uiId={`${pageId}-field-student-id`}
              name="studentId"
              value={values['studentId'] ?? ''}
              onChange={(next) => {
                set('studentId', next);
              }}
              options={overrideOptions('studentId') ?? TRAINING_STUDENT_OPTIONS}
              {...(overrideOptions('studentId') ? {} : { placeholder: '請選擇' })}
            />
          </div>
        </>
      }
    />
  );
}

/** 訓練計畫空值檢查（clertCerk.jsp :1436 undefined/''/parseInt<0）。 */
function isPlanUnselected(value: string | undefined): boolean {
  if (value === undefined || value === '') {
    return true;
  }
  const num = Number.parseInt(value, 10);
  return Number.isNaN(num) ? false : num < 0;
}

// ---------------------------------------------------------------------------
// 2. 學習歷程下載（tsgh-study-history-list；complexBody）。
// ---------------------------------------------------------------------------

export function StudyHistoryListBody({ pageId }: { pageId: string }): ReactElement {
  const dialogs = useDialogs();
  const dataSource = useDataSource();
  const [values, setValues] = useState<Record<string, string>>({
    organizationId: 'org-1',
    annualId: '115',
    jobTypeId: '1',
    departmentId: '',
    planTargetId: '-1',
    phaseTargetId: '',
    searchStudentCode: '',
    studentId: '',
    csrfToken: 'csrf-mock',
  });
  const [rows, setRows] = useState<readonly Row[]>([]);
  const [busy, setBusy] = useState(false);
  // 批次 52 修訂（b52-calibrate3，F-2）：OPTION_SET_OVERRIDES 命中＝凍結選項集取代寫死常數（規格 §7.1）。
  const overrideOptions = (name: string) => selectOptionsOverride(pageId, name);
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  /** doQuery（:1581-1603）：查詢端點未映射 → data-effect 照帶＋endpoint 級 parity 登記。 */
  const doQuery = () => {
    void (async () => {
      setBusy(true);
      try {
        const result = await dataSource.list(pageId, { page: 1, pageSize: 50, filters: { ...values } });
        setRows(result.rows.filter((row) => row['planInstId'] !== undefined));
      } catch (cause: unknown) {
        await dialogs.alert(cause instanceof Error ? cause.message : '查詢失敗');
      } finally {
        setBusy(false);
      }
    })();
  };
  /** doExport（:1504-1544）：jobTypeId!=='2' → [限 西醫PGY]!；planTargetId==='-1' → 需選定訓練計畫；
   *  endpoint-map #export path 錯置（downloadStudyHistory）→ data-effect 照帶＋path 差異登記。 */
  const doExport = () => {
    void (async () => {
      if ((values['jobTypeId'] ?? '') !== '2') {
        await dialogs.alert('匯出 計畫學員於該計畫中的平均成績、排名、百分比 [限 西醫PGY]!');
        return;
      }
      if ((values['planTargetId'] ?? '') === '-1') {
        await dialogs.alert('匯出 需選定訓練計畫');
        return;
      }
      await runReportExport({
        pageId,
        filters: { ...values },
        dataSource,
        dialogs,
      });
    })();
  };
  /** downloadPassport（:1553-1579）：chkDownloadStudyHistory 頁面專屬端點（無條目）＝
   *  誠實無 data-effect；success→window.open（雛形提示，B1-3 模式）；失敗 alert(desc)。 */
  const downloadPassport = (isFull: boolean, planInstId: string) => {
    void (async () => {
      setBusy(true);
      try {
        await dialogs.info(
          `雛形不開新視窗下載（legacy：chkDownloadStudyHistory → downloadStudyHistory?isFull=${isFull}&planInstId=${planInstId}${isFull ? '' : '，視窗名 aa'}）。`,
        );
      } finally {
        setBusy(false);
      }
    })();
  };
  const columns: readonly TableColumn[] = [
    { key: 'passport', header: '歷程', align: 'center' },
    { key: 'annualIdName', header: '年度', align: 'center' },
    { key: 'planTargetIdName', header: '訓練計畫', align: 'center' },
    { key: 'studentEmployeeId', header: '學員員編', align: 'center' },
    { key: 'studentSchoolId', header: '學號', align: 'center' },
    { key: 'studentIdName', header: '學員', align: 'center' },
    { key: 'mentorIdName', header: '導師', align: 'center' },
  ];
  return (
    <CustomerDisplayShell
      pageId={pageId}
      title="學習歷程下載"
      busy={busy}
      actions={
        <>
          <DisplayQueryButton pageId={pageId} label="查詢" effect={`list:${pageId}` as EffectKey} onClick={doQuery} />
          {/* 匯出鈕（btn-info；:1425 onclick=doExport）＝fileDownload（#export 錯置登記）。 */}
          <Button
            uiId={`${pageId}-export-btn`}
            variant="default"
            size="sm"
            type="button"
            dataEffect={`list:${pageId}#export` as EffectKey}
            onClick={doExport}
          >
            匯出
          </Button>
        </>
      }
      table={
        <Table
          uiId={`${pageId}-result-table`}
          columns={columns}
          rows={rows.map((row) => ({ ...row }))}
          rowKey={(row) => String(row['planInstId'] ?? '')}
          renderCell={(row, columnKey) => {
            // 歷程欄（genDownloadBtn :1547-1551）：下載(完整)＋br＋下載(摘要)。
            if (columnKey === 'passport') {
              const planInstId = String(row['planInstId'] ?? '');
              return (
                <>
                  <button
                    type="button"
                    data-ui-id={`${pageId}-download-full-${planInstId}`}
                    className={LINK_TEXT_CLASS}
                    onClick={() => {
                      downloadPassport(true, planInstId);
                    }}
                  >
                    下載(完整)
                  </button>
                  <br />
                  <button
                    type="button"
                    data-ui-id={`${pageId}-download-summary-${planInstId}`}
                    className={LINK_TEXT_CLASS}
                    onClick={() => {
                      downloadPassport(false, planInstId);
                    }}
                  >
                    下載(摘要)
                  </button>
                </>
              );
            }
            const value = row[columnKey];
            return value === null || value === undefined ? '' : String(value);
          }}
        />
      }
      fields={
        <>
          <div>
            <label htmlFor={`${pageId}-field-annual-id`} className="text-sm">
              <span className="text-danger">*</span>學年度：
            </label>
            <Select
              uiId={`${pageId}-field-annual-id`}
              name="annualId"
              value={values['annualId'] ?? ''}
              onChange={(next) => {
                set('annualId', next);
              }}
              options={overrideOptions('annualId') ?? COURSE_CLAZZ_ANNUAL_OPTIONS}
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-organization-id`} className="text-sm">
              <span className="text-danger">*</span>醫院：
            </label>
            <Select
              uiId={`${pageId}-field-organization-id`}
              name="organizationId"
              value={values['organizationId'] ?? ''}
              onChange={(next) => {
                set('organizationId', next);
              }}
              options={overrideOptions('organizationId') ?? ACCOUNT_ORGANIZATION_OPTIONS}
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-job-type-id`} className="text-sm">
              <span className="text-danger">*</span>訓練類別：
            </label>
            <Select
              uiId={`${pageId}-field-job-type-id`}
              name="jobTypeId"
              value={values['jobTypeId'] ?? ''}
              onChange={(next) => {
                set('jobTypeId', next);
              }}
              options={overrideOptions('jobTypeId') ?? CUSTOMER_STUDY_HISTORY_JOB_TYPE_OPTIONS}
              {...(overrideOptions('jobTypeId') ? {} : { placeholder: '請選擇' })}
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-department-id`} className="text-sm">
              <span className="text-danger">*</span>部門：
            </label>
            <Select
              uiId={`${pageId}-field-department-id`}
              name="departmentId"
              value={values['departmentId'] ?? ''}
              onChange={(next) => {
                set('departmentId', next);
              }}
              options={overrideOptions('departmentId') ?? ACCOUNT_DEPARTMENT_OPTIONS}
              {...(overrideOptions('departmentId') ? {} : { placeholder: '請選擇' })}
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-plan-target-id`} className="text-sm">
              <span className="text-danger">*</span>訓練計畫：
            </label>
            <Select
              uiId={`${pageId}-field-plan-target-id`}
              name="planTargetId"
              value={values['planTargetId'] ?? ''}
              onChange={(next) => {
                set('planTargetId', next);
              }}
              // doExport :1513 檢核 '-1'＝「全部」選項（doExport 需選定訓練計畫）。
              options={overrideOptions('planTargetId') ?? CUSTOMER_STUDY_HISTORY_PLAN_TARGET_OPTIONS}
              {...(overrideOptions('planTargetId') ? {} : { placeholder: '請選擇' })}
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-phase-target-id`} className="text-sm">
              組別：
            </label>
            <Select
              uiId={`${pageId}-field-phase-target-id`}
              name="phaseTargetId"
              value={values['phaseTargetId'] ?? ''}
              onChange={(next) => {
                set('phaseTargetId', next);
              }}
              options={overrideOptions('phaseTargetId') ?? TRAINING_PHASE_TARGET_OPTIONS}
              {...(overrideOptions('phaseTargetId') ? {} : { placeholder: '請選擇' })}
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-search-student-code`} className="text-sm">
              學員：
            </label>
            <TextInput
              uiId={`${pageId}-field-search-student-code`}
              name="searchStudentCode"
              value={values['searchStudentCode'] ?? ''}
              onChange={(next) => {
                set('searchStudentCode', next);
              }}
              placeholder="(請輸入學員姓名或學員編號)"
            />
          </div>
          <div>
            <label htmlFor={`${pageId}-field-student-id`} className="text-sm">
              {' '}
            </label>
            <Select
              uiId={`${pageId}-field-student-id`}
              name="studentId"
              value={values['studentId'] ?? ''}
              onChange={(next) => {
                set('studentId', next);
              }}
              options={overrideOptions('studentId') ?? TRAINING_STUDENT_OPTIONS}
              {...(overrideOptions('studentId') ? {} : { placeholder: '請選擇' })}
            />
          </div>
          <input type="hidden" data-ui-id={`${pageId}-field-csrf-token`} name="csrfToken" value={values['csrfToken'] ?? ''} />
        </>
      }
    />
  );
}

// ---------------------------------------------------------------------------
// 批次 42（GNL-005-d，issue #40 W12②）：實習證明單樣板維護
// （customer-tsgh-cert-template-cfg；origin certTemplateCfg.jsp 140 行）。
// display 頁型 complexBody 整頁置換（DisplayPage 批次 17 B8-3 早退先例），
// DisplayPage 泛用 stub dl（recon-B #9）隨註冊自然消失。契約 fields=[]（無資料面），
// 頁面＝h5＋兩個 form-group（label＋file accept=".doc, .docx"＋上傳＋下載）。
// ---------------------------------------------------------------------------
/** certTemplateCfg.jsp:14-56 save(kind) 逐行鏡像（未選檔 alert→副檔名白名單→sysConfirm→死路徑）。 */
export function CertTemplateBody({ pageId }: { pageId: string }): ReactElement {
  const dialogs = useDialogs();
  const [files, setFiles] = useState<Record<'cht' | 'eng', File | null>>({ cht: null, eng: null });

  const save = (kind: 'cht' | 'eng') => {
    void (async () => {
      // ①未選檔 → showAlertDialog('未選擇檔案')（:16/:27 逐字，無驚嘆號）。
      if (files[kind] === null) {
        await dialogs.alert('未選擇檔案');
        return;
      }
      // ②副檔名白名單（isDocFileTypeAllow :64-70：doc/docx）→不在→errorDocFileTypeDialog
      //   （:71-74 逐字；<br>＝alert 的 HTML 換段，同 AccountBulkToolbar alert 先例以 JSX 呈現）。
      const ext = (files[kind]?.name ?? '').split('.').pop()?.toLowerCase() ?? '';
      if (ext !== 'doc' && ext !== 'docx') {
        await dialogs.alert(
          <span>
            檔案上傳限制：僅支援以下副檔名
            <br />
            文書類：doc、docx
          </span>,
        );
        return;
      }
      // ③sysConfirm（:40 逐字，半形?）。
      const confirmed = await dialogs.confirm('是否確定要上傳?');
      if (!confirmed) {
        return;
      }
      await dialogs.processing.wrap(
        new Promise<void>((resolve) => {
          setTimeout(resolve, 0);
        }),
      );
      // ④死路徑（:46-63）：POST customer/tsgh/save{,Eng}CertTemplateAjax；legacy .done
      //   依 response.status 分岔（desc 由真後端回）、ajax error 無 .fail callback＝無訊息。
      //   雛形不虛構成功/失敗訊息（ImportToolbar 批次 9 慣例；登記 legacy-known-issue）。
    })();
  };

  /** downFile（:52-57）：$.fileDownload(downloadFileUrl + '/downloadAttachByRef?refId=1&refTable='
   *  + kind)＝死路徑（雛形無檔案、端點無映射；kind＝chtCertTemplate／engCertTemplate，
   *  照帶＋登記）；legacy .fail→showAlertDialog('下載檔案失敗！')＝照實鏡像 fail 路徑。 */
  const downFile = () => {
    void (async () => {
      await dialogs.alert('下載檔案失敗！'); // :56 逐字
    })();
  };

  const group = (kind: 'cht' | 'eng', label: string) => (
    <div key={kind} className="mb-2 flex flex-wrap items-center gap-2">
      {/* biome-ignore lint/a11y/noLabelWithoutControl: 逐字鏡像 legacy 純文字 label（:111/:123 col-md-3）。 */}
      <label className="text-sm font-bold text-ink">{label}</label>
      <input
        type="file"
        data-ui-id={`${pageId}-${kind}-cert`}
        accept=".doc, .docx" // :113/:125 逐字
        className="text-xs"
        onChange={(event) => {
          setFiles((current) => ({ ...current, [kind]: event.target.files?.[0] ?? null }));
        }}
      />
      <Button
        uiId={`${pageId}-${kind}-upload`}
        variant="primary"
        size="sm"
        type="button"
        onClick={() => {
          save(kind);
        }}
      >
        上傳
      </Button>
      <Button
        uiId={`${pageId}-${kind}-download`}
        variant="default"
        size="sm"
        type="button"
        // refTable＝chtCertTemplate／engCertTemplate（:119/:131 onclick 逐字；死路徑註解見 downFile）。
        onClick={() => {
          downFile();
        }}
      >
        下載
      </Button>
    </div>
  );

  return (
    <div data-ui-id={pageId}>
      <LegacyContractModals pageId={pageId} />
      <ContentPanel
        uiId={`${pageId}-panel`}
        title="實習證明單樣板維護" // routes.generated.ts:349（＝certTemplateCfg.jsp:105 h5）
        headingLevel={panelHeadingLevelFor(pageId)}
      >
        {group('cht', '中文實習證明單樣板：')} {/* :111；downFile refTable=chtCertTemplate（:119） */}
        {group('eng', '英文實習證明單樣板：')} {/* :123；downFile refTable=engCertTemplate（:131） */}
      </ContentPanel>
    </div>
  );
}
